/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Tag_Section_TitleInputs */

const en_directory_taxonomy_index_tag_section_title = /** @type {(inputs: Directory_Taxonomy_Index_Tag_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse all tags`)
};

const zh_directory_taxonomy_index_tag_section_title = /** @type {(inputs: Directory_Taxonomy_Index_Tag_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览全部标签`)
};

/**
* | output |
* | --- |
* | "Browse all tags" |
*
* @param {Directory_Taxonomy_Index_Tag_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_tag_section_title = /** @type {((inputs?: Directory_Taxonomy_Index_Tag_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Tag_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_tag_section_title(inputs)
	return zh_directory_taxonomy_index_tag_section_title(inputs)
});
export { directory_taxonomy_index_tag_section_title as "directory.taxonomy_index.tag.section_title" }